export var MuiAlert = {
    styleOverrides: {
        standardInfo: function (_a) {
            var theme = _a.theme;
            return ({
                backgroundColor: theme.palette.info[100],
                color: theme.palette.info[800],
                ".MuiAlert-icon": { color: theme.palette.info[600] },
            });
        },
        standardSuccess: function (_a) {
            var theme = _a.theme;
            return ({
                backgroundColor: theme.palette.success[100],
                color: theme.palette.success[800],
                ".MuiAlert-icon": { color: theme.palette.success[600] },
            });
        },
        standardWarning: function (_a) {
            var theme = _a.theme;
            return ({
                backgroundColor: theme.palette.warning[100],
                color: theme.palette.warning[800],
                ".MuiAlert-icon": { color: theme.palette.warning[600] },
            });
        },
        standardError: function (_a) {
            var theme = _a.theme;
            return ({
                backgroundColor: theme.palette.error[100],
                color: theme.palette.error[800],
                ".MuiAlert-icon": { color: theme.palette.error[600] },
            });
        },
        root: function (_a) {
            var theme = _a.theme;
            return ({
                fontSize: 16,
                padding: theme.spacing(0.5, 2),
            });
        },
    },
};
